import styled from 'styled-components';
import { InputStyles } from '../Form.styles';

export const InputWrapper = styled.div``;

export const InputField = styled.input<{ hasError }>`
	${InputStyles}
`;
